import { OptionTemplate } from "shared/api/middleware-api-client";
import { REACT_APP_GERS_API_URL } from "shared/config";
import Icon, { IconTypes } from "shared/ui/icon";
import Text from "shared/ui/typography/Text";
import { getDoorProductURL } from "shared/utils/getDoorProductURL";
import MonthlyPayment from "widgets/shared/monthly-payment";

export const SuggestedProductCard = ({
  product,
  paymentData,
}: {
  product: OptionTemplate;
  paymentData: any;
}) => {
  const productURL = getDoorProductURL(product);
  const path = `${REACT_APP_GERS_API_URL}/OptionTemplateContainers/download?fileId=${product.imageId}`;

  return (
    <a
      href={productURL}
      className="gg-transform-gpu gg-group gg-overflow-hidden  gg-bg-gray-50 gg-cursor-pointer gg-transition gg-duration-500 gg-ease-in-out gg-rounded gg-border  hover:gg-border-gray-400 gg-border-gray-200 gg-border-dotted gg-flex gg-flex-row sm:gg-flex-col  gg-w-full"
    >
      <div className="gg-overflow-hidden gg-aspect-[0.83] gg-relative gg-w-[26%] sm:gg-w-full sm:gg-h-60 ">
        <img
          src={path}
          alt="A suggested door product for sale"
          className="group-hover:gg-scale-110 gg-transition gg-duration-300 gg-ease-in-out gg-absolute gg-inset-0 gg-w-full gg-h-full gg-object-center gg-object-cover"
        />
      </div>

      <div className="gg-py-3 gg-py-gg-grid gg-w-[74%]  sm:gg-w-full">
        {/* lg:gg-h-16 */}
        <div className=" gg-px-3.5">
          <h3 className="gg-text-xs gg-font-bold gg-tracking-wider gg-text-gray-500 gg-uppercase">
            Gewoonleuk
          </h3>
          <Text className="gg-truncate gg-uppercase gg-mt-1 gg-w-full gg-text-sm gg-font-extrabold gg-tracking-wide gg-text-slate-800">
            {product.name}
          </Text>
          <Text className="gg-text-sm">Op maat voor jouw kozijn</Text>
        </div>

        <div className="gg-mt-6 gg-border-t gg-border-gray-200 ">
          <div className="gg-px-3.5 gg-mt-2 gg-flex gg-justify-between gg-items-center gg-h-full">
            <div className="gg-flex gg-flex-col">
              <h3 className="gg-text-slate-800 gg-font-bold gg-text-lg">
                <span className="gg-mr-0.5">€</span>
                {product.price}
                <span className="gg-ml-1.5 gg-text-xs gg-font-light gg-text-zinc-400">
                  incl. btw.
                </span>
              </h3>
              <div className="gg-hidden sm:gg-block">
                <MonthlyPayment
                  monthlyPayment={paymentData}
                  showInfoButton={false}
                />
              </div>
            </div>
            <Icon
              name={IconTypes.ARROW_RIGHT}
              className="gg-cursor-pointer hover:gg-scale-110 gg-transition gg-duration-300 gg-ease-in-out"
            />
          </div>
        </div>
      </div>
    </a>
  );
};
